/**
 * AP Invoices Demo — workflow build store mutations.
 *
 * THROWAWAY DEMO CODE. Shared by the "describe the workflow" prompt in the
 * create-workflow modal and the Nami chat tools (`ApWorkflowTools`). Delete with
 * src/demo/ap.
 */

import { updateApDemoState } from '../fixture-store';

/** Reveal the base AP pipeline (no confidence gate yet). */
export function startApWorkflowBuild(): void {
  updateApDemoState((s) => {
    s.apWorkflow = { built: true, confidenceAdded: false };
  });
}

/** Append the auto-accept confidence gate to the built pipeline. */
export function addApConfidenceStep(): void {
  updateApDemoState((s) => {
    s.apWorkflow = { built: true, confidenceAdded: true };
  });
}

/**
 * Hand-off for the create-workflow "describe it" prompt. The Workflows list sets
 * the typed description here and navigates to the build canvas, where
 * `useApWorkflowDescribeAutostart` consumes it (once the chat module is
 * registered) to open the panel and stream Nami's build turn. A module-level
 * variable (not the store) since it's a one-shot signal across a navigation, not
 * resettable demo state.
 */
let pendingDescribe: string | null = null;

export function setPendingApWorkflowDescribe(text: string): void {
  pendingDescribe = text;
}

export function consumePendingApWorkflowDescribe(): string | null {
  const text = pendingDescribe;
  pendingDescribe = null;
  return text;
}
